import { SubscriptionTier } from './types';

/**
 * The tier a Stripe product names, by its last whitespace-separated word ("Smart Send Plus" ->
 * 'plus'). Product names are brand-prefixed, so the whole string never matches.
 *
 * This reads LIVE catalogue data rather than a mirrored list of lookup keys. A key list has to be
 * kept in step with Stripe by hand, and the failure mode when it drifts is a tier the customer
 * cannot buy - whereas a product this app does not recognise simply is not offered, which is the
 * honest outcome. Note `productDescription` carries the tiers' older names ("Smart Send Prime",
 * "Smart-Send Ultimate") and is deliberately not read.
 */
export function resolveTierFromProductName(productName: string | null | undefined): SubscriptionTier | null {
  const lastWord = productName?.trim().split(/\s+/).pop()?.toLowerCase();
  if (lastWord === 'pro') return 'pro';
  if (lastWord === 'plus') return 'plus';
  return null;
}
